// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2nxUD","title":"styles_title__1tZvv","subtitle":"styles_subtitle__Y0OBM","items":"styles_items__3uow0"};